/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guides_IntroInputs */

const en_guides_intro = /** @type {(inputs: Guides_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn everything about JSON: from basics to advanced topics. Each guide includes practical examples you can try with our free tools.`)
};

const ko_guides_intro = /** @type {(inputs: Guides_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON의 기초부터 고급 주제까지 모든 것을 배워보세요. 각 가이드에는 무료 도구로 직접 시도해볼 수 있는 실용적인 예제가 포함되어 있습니다.`)
};

const ja_guides_intro = /** @type {(inputs: Guides_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONの基礎から応用まで学べます。各ガイドには、無料ツールで試せる実践的な例が含まれています。`)
};

/**
* | output |
* | --- |
* | "Learn everything about JSON: from basics to advanced topics. Each guide includes practical examples you can try with our free tools." |
*
* @param {Guides_IntroInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guides_intro = /** @type {((inputs?: Guides_IntroInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guides_IntroInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guides_intro(inputs)
	if (locale === "ko") return ko_guides_intro(inputs)
	return ja_guides_intro(inputs)
});